module.exports = __webpack_public_path__ + "7855d069972d9e39f1787be701192a34.jpg";